import { Axios } from '../axiosInstance';

const axiosInstance = Axios();

const previewManager = {
  getPreview(url: any) {
    return axiosInstance.v2({
      url: url,
      method: 'GET'
    });
  }
};

export default previewManager;
